import Api from '../Base'

class PostSpaceAssignment extends Api {
  requestUrl = '/api/SpaceAssignment'

  method = 'POST'
}

export default PostSpaceAssignment
